import z from 'zod';

export const contactWithMessageCountSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  lastMessageDate: z.number().nullable(),
  amountOfNotReadMessages: z.string().nullable(),
});

export type ContactWithMessageCount = z.infer<
  typeof contactWithMessageCountSchema
>;
